// Staff copy for the per-ticket report (build 4): the Tickets tab of Reports and
// its words for results and redirects. The server's files use the same words, in
// internal/report/ticketwords.go; change both, in all three languages, at once.
// Native review pending (az, ru): the Azerbaijani and Russian here are a first draft.
import type { Phrase } from '../staffText'

export const tickets = {
  'tickets.tabFigures': { en: 'Figures', az: 'Göstəricilər', ru: 'Показатели' },
  'tickets.tabTickets': { en: 'Tickets', az: 'Talonlar', ru: 'Талоны' },
  'tickets.branchesN': { en: '{n} branches', az: '{n} filial', ru: 'Отделений: {n}' },
  'tickets.search': { en: 'Ticket number', az: '', ru: '' },
  'tickets.all': { en: 'All', az: 'Hamısı', ru: 'Все' },
  'tickets.service': { en: 'Service', az: 'Xidmət', ru: 'Услуга' },
  'tickets.employee': { en: 'Employee', az: 'Əməkdaş', ru: 'Сотрудник' },
  'tickets.result': { en: 'Result', az: 'Nəticə', ru: 'Результат' },
  'tickets.channel': { en: 'Online or branch', az: 'Onlayn və ya filial', ru: 'Онлайн или отделение' },
  'tickets.online': { en: 'Online', az: 'Onlayn', ru: 'Онлайн' },
  'tickets.inBranch': { en: 'Branch', az: 'Filial', ru: 'Отделение' },
  'tickets.excel': { en: 'Excel', az: 'Excel', ru: 'Excel' },
  'tickets.csv': { en: 'CSV', az: 'CSV', ru: 'CSV' },
  'tickets.countTickets': { en: '{n} ticket|{n} tickets', az: '{n} talon', ru: '{n} талон|{n} талона|{n} талонов' },
  'tickets.countRows': { en: '{n} row|{n} rows', az: '{n} sətir', ru: '{n} строка|{n} строки|{n} строк' },
  'tickets.none': { en: 'No tickets', az: 'Talon yoxdur', ru: 'Талонов нет' },
  'tickets.previous': { en: 'Previous', az: 'Əvvəlki', ru: 'Назад' },
  'tickets.next': { en: 'Next', az: 'Növbəti', ru: 'Далее' },

  'tickets.col.branch': { en: 'Branch', az: 'Filial', ru: 'Отделение' },
  'tickets.col.employee': { en: 'Employee', az: 'Əməkdaş', ru: 'Сотрудник' },
  'tickets.col.section': { en: 'Section / menu', az: 'Bölmə / menyu', ru: 'Раздел / меню' },
  'tickets.col.desk': { en: 'Counter', az: 'Pəncərə', ru: 'Окно' },
  'tickets.col.number': { en: 'Ticket number', az: 'Talon nömrəsi', ru: 'Номер талона' },
  'tickets.col.date': { en: 'Date', az: 'Tarix', ru: 'Дата' },
  'tickets.col.taken': { en: 'Ticket taken', az: 'Talonun vurulduğu vaxt', ru: 'Талон получен' },
  'tickets.col.start': { en: 'Service start', az: 'Xidmətə başlama vaxtı', ru: 'Начало обслуживания' },
  'tickets.col.end': { en: 'Service end', az: 'Xidməti bitirmə vaxtı', ru: 'Конец обслуживания' },
  'tickets.col.serviceTime': { en: 'Service duration', az: 'Xidmətin müddəti', ru: 'Длительность обслуживания' },
  'tickets.col.wait': { en: 'Wait duration', az: 'Gözləmə müddəti', ru: 'Время ожидания' },
  'tickets.col.result': { en: 'Result', az: 'Nəticə', ru: 'Результат' },
  'tickets.col.redirected': { en: 'Redirected', az: 'Yönləndirilib', ru: 'Перенаправлен' },
  'tickets.col.redirectedBy': { en: 'Redirected by', az: 'Yönəldən əməkdaş', ru: 'Кто перенаправил' },
  'tickets.col.redirectedTo': { en: 'Redirected to', az: 'Yönəldilən əməkdaş', ru: 'Кому перенаправлен' },
  'tickets.col.channel': { en: 'Online or branch', az: 'Onlayn və ya filial', ru: 'Онлайн или отделение' },
  'tickets.col.viaToken': { en: 'Via token', az: 'Token ilə', ru: 'Через токен' },

  'tickets.result.served': { en: 'Served', az: 'Xidmət göstərilib', ru: 'Обслужен' },
  'tickets.result.redirected': { en: 'Redirected', az: 'Yönləndirilib', ru: 'Перенаправлен' },
  'tickets.result.no_show': { en: 'No-show', az: 'Yaxınlaşmadı', ru: 'Не подошёл' },
  'tickets.result.cancelled': { en: 'Cancelled', az: 'Ləğv edilib', ru: 'Отменён' },
  'tickets.result.left': { en: 'Left', az: 'Gedib', ru: 'Ушёл' },
  'tickets.result.not_reached': { en: 'Not reached', az: 'Növbə çatmayıb', ru: 'Не дошла очередь' },

  'tickets.redirect.no': { en: 'No', az: 'Xeyr', ru: 'Нет' },
  'tickets.redirect.back': { en: 'Back to operator', az: 'Əməkdaşa geri', ru: 'Обратно к сотруднику' },
  'tickets.redirect.person': { en: 'To colleague', az: 'Həmkara', ru: 'Коллеге' },
  'tickets.redirect.desk': { en: 'To {code}', az: 'Pəncərə {code}', ru: 'Окно {code}' },
} satisfies Record<`tickets.${string}`, Phrase>
